import React from "react";
import { Box, Typography } from "@mui/material";
import InsertDriveFile from "@mui/icons-material/InsertDriveFile";
import { useTranslation } from "react-i18next";

export const EmptyFileState: React.FC = () => {
  const { t } = useTranslation();

  return (
    <Box sx={{ p: 4, textAlign: "center" }}>
      <InsertDriveFile sx={{ fontSize: 48, color: "text.secondary", mb: 2 }} />
      <Typography variant="h6" color="text.secondary" gutterBottom>
        {t("noFilesUploadedYet")}
      </Typography>
      <Typography variant="body2" color="text.secondary">
        {t("uploadFirstFileInstruction")}
      </Typography>
    </Box>
  );
};
